export default "__VITE_ASSET__49J3oGXz__"